import { ActionButton } from "@/shared/ui/action-button"
import EditSvg from '@/shared/assets/images/Pencil.svg'
import { useUpdatePartnerDiscountModals } from "@/features/update-partner-discount"
import { useAppDispatch } from "@/shared/lib/redux"
import { fetchPartnerDiscounts } from "../../model"
import { IPartnerDiscount } from "@/shared/api/partners"
import { FC } from "react"

interface UpdateDiscountProps {
    discount: IPartnerDiscount
}

export const UpdateDiscount: FC<UpdateDiscountProps> = ({ discount }) => {
    const { openUpdateDiscountModal } = useUpdatePartnerDiscountModals()
    const dispatch = useAppDispatch()

    const onUpdate = () => {
        dispatch(fetchPartnerDiscounts())
    }

    return (
        <ActionButton 
            onClick={() => openUpdateDiscountModal(discount, onUpdate)}
            icon={EditSvg} 
        />
    )
}